import { Injectable, signal } from "@angular/core";
import type { ChatSidebarApi } from "@tylertech/smart-pulse-foundry-chat-sidebar";
import { Observable, Subject } from "rxjs";

@Injectable()
export class TylerAssistantSidebarService
{
    private readonly reconnectRequestedSubject = new Subject<void>();

    readonly sidebar = signal<ChatSidebarApi | undefined>(undefined);
    readonly foundryUnavailable = signal(false);
    readonly fallbackOpen = signal(false);
    readonly reconnectRequested: Observable<void> = this.reconnectRequestedSubject.asObservable();

    requestReconnect(): void
    {
        this.reconnectRequestedSubject.next();
    }
}
